<template>
  <ion-page>
    <ion-content v-if="email">
      <ion-grid>
        <ion-row>
          <ion-col class="ion-text-center" size="12">
            <label class="text-xl font-bold" style="font-size: 17px">オンラインショップとポイントをまとめる</label>
          </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col size="auto">
            <img :src="ShopImage" alt="shop-image" />
          </ion-col>
        </ion-row>
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col size="auto">
            <img :src="UniteImage" alt="unite-image" />
          </ion-col>
        </ion-row>
        <ion-grid>
          <form>
            <div v-if="canUseEmail == false" class="ec-login-border ion-padding-horizontal">
              <ion-row>
                <ion-col class="ion-text-center ion-margin-top" size="12">
                  <ion-label class="font-bold text-xl text-danger">オンラインショップにログイン</ion-label>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-label>ポイントをまとめるには、オンラインショップとのID連携が必要です。</ion-label><br/>
                  <ion-label>オンラインショップに登録しているパスワードでログインしてください。</ion-label><br/>
                  <ion-label>IDを連携すると、解除はできませんのであらかじめご了承ください。</ion-label>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <p class="input-label ion-no-margin ion-margin-top font-bold">メールアドレス</p>
                  <ion-item fill="outline" class="containers">
                    <ion-input class="mail-addless-input" v-model="email" placeholder="メールアドレス" :disabled="true"></ion-input>
                  </ion-item>
                  <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col>
                  <p class="input-label ion-no-margin ion-margin-top font-bold">パスワード</p>
                  <ion-item fill="outline">
                    <ion-input :type="show_password ? 'text' : 'password'" v-model="password">
                      <ion-button slot="end" size="small" @click="show_password = !show_password">
                        <ion-icon slot="icon-only" color="black" :icon="eye"></ion-icon>
                      </ion-button>
                    </ion-input>
                  </ion-item>
                  <ion-text color="danger" v-if="errors && errors.password" >{{ errors.password }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-label style="color: #00AFEC" class="text-sm">※パスワードをお忘れの場合は、オンラインショップにて再発行をお願いいたします。</ion-label>
                </ion-col>
              </ion-row>

              <ion-row class="ion-justify-content-center ion-text-center ion-margin-bottom">
                <ion-col>
                  <ion-button class="font-bold primary-button ion-padding-horizontal" @click="login">ログイン</ion-button>
                </ion-col>
              </ion-row>
            </div>
            <div v-else-if="canUseEmail == true" class="ec-login-border">
              <ion-row>
                <ion-col class="ion-text-center ion-margin-top" size="12">
                  <ion-label class="font-bold text-xl text-danger">現在アプリにご登録のメールアドレス</ion-label>
                </ion-col>
                <ion-col class="ion-text-center" size="12">
                  <ion-label>{{email}}</ion-label>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-padding-horizontal ion-margin-top">
                  <ion-label style="font-size: 15px">ポイントをまとめるには、アプリとオンラインショップで同じメールアドレスをご登録いただく必要がございます。</ion-label><br/>
                  <ion-label style="font-size: 15px">すでにオンラインショップのアカウントをお持ちの方は、どちらかのメールアドレスにあわせていただきますようお願いいたします。</ion-label><br/>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-margin-top">
                  <ion-label style="font-size: 15px" class="font-bold">すでにオンラインショップ会員に登録済の方</ion-label>
                </ion-col>
              </ion-row>
              <ion-row class="ion-justify-content-center ion-text-center">
                <ion-col size="11">
                  <ion-button style="font-size: 15px" href="/other/my-page/mail-change" class="font-bold primary-button" expand="block">オンラインショップにご登録の<br/>メールアドレスに合わせる</ion-button>
                </ion-col>
              </ion-row>

              <ion-row class="ion-justify-content-center ion-text-center">
                <ion-col size="11">
                  <ion-button style="font-size: 15px" @click="openEcMailValidate" class="font-bold primary-button" expand="block">アプリにご登録の<br/>メールアドレスに合わせる</ion-button>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col class="ion-margin-top">
                  <ion-label style="font-size: 15px" class="font-bold">オンラインショップ会員を登録されていない方</ion-label>
                </ion-col>
              </ion-row>
              <ion-row class="ion-justify-content-center ion-text-center ion-margin-bottom">
                <ion-col size="11">
                  <ion-button style="font-size: 15px" href="/ec/register" class="font-bold primary-button" expand="block">オンラインショップ会員に<br/>新規登録する</ion-button>
                </ion-col>
              </ion-row>
            </div>
          </form>
        </ion-grid>
      </ion-grid>

      <div v-if="isConfirmDialogOpen">
        <ion-backdrop class="ion-backdrop-custom" />
        <div class="modal-container ion-justify-content-center ion-text-center">
          <p class="text-danger font-bold">必ずご確認ください</p>
          <p class="ion-text-left">
            IDを連携した後の解除・取消はできません。<br/>
            また、アプリにご登録の各種情報を更新すると、オンラインショップの情報も更新されます。
          </p>
          <ion-button class="font-bold primary-button" expand="block" @click="confirm">確認した</ion-button>
          <ion-button color="danger" fill="outline" expand="block" @click="isConfirmDialogOpen = false" class="font-bold ion-margin-top">キャンセル</ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonBackdrop, IonButton,
  IonCol,
  IonContent,
  IonGrid, IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
  IonText, onIonViewWillEnter
} from "@ionic/vue";
import UniteImage from '@/assets/ec_icon/unite_image.png';
import ShopImage from '@/assets/ec_icon/shop_image.png';
import {useField, useForm, useFormErrors} from "vee-validate";
import {ref} from "vue";
import request from "@/utils/Request";
import { appendUtmParams } from "@/utils/url-utils";
import { presentToast } from "@/helpers/presentToast";
import {useRouter} from "vue-router";
import * as yup from "yup";
import {eye} from "ionicons/icons";

const router = useRouter();
const isConfirmDialogOpen = ref(false)
const canUseEmail = ref(null)
const show_password = ref(false);

// 環境変数からEC連携URLを取得（型安全性と検証を追加）
const baseUrl: string = import.meta.env.VITE_EC_MAIL_VALIDATE_URL || '';
if (!baseUrl) {
  console.error('VITE_EC_MAIL_VALIDATE_URL is not defined');
}
const ecMailValidateUrl: string = baseUrl ? appendUtmParams(baseUrl) : '';

const schema = yup.object({
  email: yup.string().required('メールアドレスをご入力ください'),
  password: yup.string().required('パスワードをご入力ください')
});

const loginForm = useForm({
  validationSchema: schema
})

const errors = useFormErrors();
const { value: password } = useField<string>("password")
const { value: email } = useField<string>("email")

onIonViewWillEnter(async() => {
  const response: any = await request.get('/ec/can-use-email');
  canUseEmail.value = response.can_use_email;
  email.value = response.email;
});
async function confirm() {
  await router.push({ name: 'ECUnite' })
}
async function openEcMailValidate() {
  if (!ecMailValidateUrl) {
    await presentToast('メールアドレス確認URLが設定されていません。');
    return;
  }
  window.location.href = ecMailValidateUrl;
}
async function login() {
  const isValid = await loginForm.validate();
  if (isValid.valid) {
    try {
      const response: any = await request.post('ec/login', {
        email: email.value,
        password: password.value
      });
      if (response.status) {
        isConfirmDialogOpen.value = true;
      }
    } catch(error: any) {
      if (error.response?.status == 422) {
        loginForm.setErrors(error.response.data.errors);
      }
    }
  }
}
</script>

<style>
.containers {
  --background: white !important;
}

.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 100;
  flex-flow: column;
  align-items: center;
  width: 80%;
  max-width: 400px;
  min-width: 280px;
  max-height: 90vh;
  border-radius: 10px;
  background-color: var(--ion-color-light);
  padding: 20px;
  box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
}

@media (max-width: 480px) {
  .modal-container {
    width: 90%;
    min-width: 260px;
    padding: 16px;
  }
}

@media (max-height: 600px) {
  .modal-container {
    max-height: 85vh;
    padding: 12px;
  }
}

.ion-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--ion-color-dark);
  opacity: 0.3;
  z-index: 99;
}
</style>